import React, { useEffect, useState } from 'react';

import styled, { css } from 'styled-components';
import { Modal } from 'react-bootstrap';

// mixin
const sizes = css`
  width: ${({ customwidth }) => customwidth !== null && customwidth + 'px'};
  height: ${({ customheight }) => customheight !== null && customheight + 'px'};
`;

// Modal styling
const CustomModal = styled(Modal)`
  .modal-dialog {
    ${sizes}
    
    .modal-content {
      ${sizes}

      .modal-body {
        padding: 0;

        img {
          ${sizes}
        }
      }
    }
  }

  @media (min-width: 576px) {
    .modal-dialog {
      max-width: ${({ customwidth }) => customwidth !== null && customwidth + 'px'};
      margin: 1.75rem auto;
    }
  }
`;

function PreviewBanner({ showPreview, setShowPreview, width, height, image, title }) {
  const [imageData, setImageData] = useState();

  useEffect(() => {
    if (image) {
      if (typeof image !== 'string') {
        let reader = new FileReader();
  
        reader.addEventListener('load', () => {
          setImageData(reader.result);
        });
  
        reader.readAsDataURL(image);
      } else {
        setImageData(image);
      }
    } else {
      setImageData();
    }
  }, [image]);

  return (
    <CustomModal
      centered
      show={showPreview}
      onHide={() => setShowPreview(false)}
      animation={false}
      customwidth={width > 0 && width !== null ? width : null}
      customheight={height > 0 && height !== null ? height : null}
    >
      <Modal.Body>
        <img src={imageData} alt={title} title={title} />
      </Modal.Body>
    </CustomModal>
  );
}

export default PreviewBanner;
